import { withReportContentModalProps } from 'viewModel/globalModals/ReportContentModal/withReportContentModalProps';
import ReportContentModal from 'components/GlobalModals/ReportContentModal/ReportContentModal';

export default withReportContentModalProps(ReportContentModal);
